import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from "app/admin/layout/footer/footer.component";
import { AlertModule } from "ngx-bootstrap/alert";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CookieService } from 'ngx-cookie-service';
import { NgxUploaderModule } from 'ngx-uploader';
import { AutofocusDirective } from '../../shared/directives/autofocus.directive';
import { LoginService } from '../../shared/pages/login/login.service';
import { AuthGuard } from '../../shared/services/authentication/guard.service';
import { JwtHttpInterceptor } from '../../shared/services/authentication/interceptor.service';
import { PCodeServices } from '../../shared/services/pcode.service';
import { EditFileConfigurationDialogComponent } from '../pages/bonus/companies/bonus-configuration/edit-config-dialog/edit-filetype-config-dialog.component';
import { FileManagerFolderDetailsDialogComponent } from '../pages/filemanager/filemanager/folder-details-dialog/folder-details-dialog.component';
import { FileManagerRenameDialogComponent } from '../pages/filemanager/filemanager/rename-dialog/rename-dialog.component';
import { AppBackdropComponent } from "./components/app_backdrop/app_backdrop.component";
import { SmdFabSpeedDialActionsComponent, SmdFabSpeedDialComponent, SmdFabSpeedDialTriggerComponent } from "./components/fab";
import { ForgotPasswordDialogComponent } from './components/forgot-password/forgot-password-dialog.component';
import { NotificationDetailsDialogComponent } from './components/notifications/notification-details-dialog/notification-details-dialog.component';
import { SendNotificationDialogComponent } from './components/notifications/send-notification-dialog/send-notification-dialog.component';
import { ResetPasswordInternalComponent } from './components/reset-password/reset-password.component';
import { TaskComponent } from './components/todo/task.component';
import { TodoComponent } from './components/todo/todo.component';
import { UploadDialogComponent } from './components/upload/upload.component';
import { WeatherComponent } from "./components/weather/weather.component";
import { UserSelectorDialogComponent } from './users/users/selector/selector.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";

@NgModule({
	declarations:
		[
			// components
			AppBackdropComponent,
			FooterComponent,
			TaskComponent,
			WeatherComponent,
			TodoComponent,
			SmdFabSpeedDialActionsComponent,
			SmdFabSpeedDialComponent,
			SmdFabSpeedDialTriggerComponent,
			ResetPasswordInternalComponent,

			// dialogs
			UploadDialogComponent,
			FileManagerFolderDetailsDialogComponent,
			FileManagerRenameDialogComponent,
			UserSelectorDialogComponent,
			SendNotificationDialogComponent,
			NotificationDetailsDialogComponent,
			ForgotPasswordDialogComponent,

			// project
			EditFileConfigurationDialogComponent,

			// directives
			AutofocusDirective
		],
	imports:
		[
			// commons
			CommonModule,
			FormsModule,
			ReactiveFormsModule,

			// material
			MatAutocompleteModule,
			MatButtonModule,
			MatButtonToggleModule,
			MatCardModule,
			MatCheckboxModule,
			MatChipsModule,
			MatDatepickerModule,
			MatDialogModule,
			MatExpansionModule,
			MatGridListModule,
			MatIconModule,
			MatInputModule,
			MatListModule,
			MatMenuModule,
			MatNativeDateModule,
			MatProgressBarModule,
			MatProgressSpinnerModule,
			MatRadioModule,
			MatRippleModule,
			MatSelectModule,
			MatSidenavModule,
			MatSliderModule,
			MatSlideToggleModule,
			MatSnackBarModule,
			MatTabsModule,
			MatStepperModule,
			MatToolbarModule,
			MatTooltipModule,
			BsDropdownModule.forRoot(),
			AlertModule.forRoot(),
			TabsModule.forRoot(),
			ModalModule.forRoot(),
			PopoverModule.forRoot(),
			TranslateModule,
			NgxUploaderModule,

			// tables
			MatTableModule,
			MatSortModule,
			MatPaginatorModule,

			// ngx-mask
			NgxMaskDirective,
			NgxMaskPipe,
		],
	exports:
		[
			// commons
			CommonModule,
			FormsModule,

			// material
			MatAutocompleteModule,
			MatButtonModule,
			MatButtonToggleModule,
			MatCardModule,
			MatCheckboxModule,
			MatChipsModule,
			MatDatepickerModule,
			MatDialogModule,
			MatExpansionModule,
			MatGridListModule,
			MatIconModule,
			MatInputModule,
			MatListModule,
			MatMenuModule,
			MatNativeDateModule,
			MatProgressBarModule,
			MatProgressSpinnerModule,
			MatRadioModule,
			MatRippleModule,
			MatSelectModule,
			MatSidenavModule,
			MatSliderModule,
			MatSlideToggleModule,
			MatSnackBarModule,
			MatTabsModule,
			MatStepperModule,
			MatToolbarModule,
			MatTooltipModule,

			// tables
			MatTableModule,
			MatSortModule,
			MatPaginatorModule,

			// ngx-mask
			NgxMaskDirective,
			NgxMaskPipe,

			SmdFabSpeedDialActionsComponent,
			SmdFabSpeedDialComponent,
			SmdFabSpeedDialTriggerComponent,
			AppBackdropComponent,
			FooterComponent,
			TaskComponent,
			WeatherComponent,
			TodoComponent,
			ReactiveFormsModule,
			TabsModule,
			BsDropdownModule,
			AlertModule,
			ModalModule,
			PopoverModule,
			TranslateModule,
			NgxUploaderModule,

			// components
			ResetPasswordInternalComponent,

			// directives
			AutofocusDirective
		],
	providers:
		[
			// custom services
			AuthGuard,
			LoginService,
			CookieService,
			PCodeServices,
			provideNgxMask(),
			{ provide: MAT_DIALOG_DATA, useValue: {} },
			{ provide: HTTP_INTERCEPTORS, useClass: JwtHttpInterceptor, multi: true },
			{ provide: MatDialogRef, useValue: {} }
		]
})
export class AdminSharedModule
{
	static forRoot(): ModuleWithProviders<AdminSharedModule>
	{
		return {
			ngModule: AdminSharedModule
		};
	}
}
